export const MAPBOX_API_KEY = 'pk.eyJ1IjoiaGVhcnRmYWlsdXJlZmZsIiwiYSI6ImNrZWVxZXBkOTA0M2Eyc3FkajRyYm02aHAifQ.Zmg9v8EdEpJ9_3GKjeJaZQ';